export default "__VITE_ASSET__C30GTg51__"